import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useNavigateBack } from '../../../hooks'
import { TAG_HEIGHT } from '../../Tag'
import { EntityProfileHeaderAvatar } from '../EntityProfileHeaderAvatar'
import {
  ENTITY_PROFILE_HEADER_TEXT_CLAMP_LINES,
  EntityProfileHeaderText,
} from '../EntityProfileHeaderText'
import { EntityProfileHeaderTitleBackButton } from '../EntityProfileHeaderTitleBackButton'
import { EntityProfileHeaderTitleToggleButton } from '../EntityProfileHeaderTitleToggleButton'
import { EntityStatus } from '../EntityStatus'

import * as styles from './EntityProfileHeaderTitleWithStatus.module.css'

function EntityProfileHeaderTitleWithStatus({
  Actions = null,
  BackButton = EntityProfileHeaderTitleBackButton,
  EntityAvatar = EntityProfileHeaderAvatar,
  Status = EntityStatus,
  Text = EntityProfileHeaderText,
  ToggleButton = EntityProfileHeaderTitleToggleButton,
  actionsProps: {
    onClickEditTitleButton,
    onToggleHeader,
    ...restActionsProps
  } = EMPTY_OBJECT,
  backButtonProps: {
    className: backButtonClassName = styles.backButton,
    ...backButtonProps
  } = EMPTY_OBJECT,
  className = styles.EntityProfileHeaderTitleWithStatus,
  entityAvatarProps,
  isArchived,
  isHeaderOpen,
  isLoading,
  openClassName = styles.open,
  sectionBackUrl,
  statusProps: {
    className: statusClassName,
    height: statusHeight = TAG_HEIGHT.height40,
    textClassName: statusTextClassName = styles.statusText,
    ...statusProps
  } = EMPTY_OBJECT,
  text,
  textContainerClassName = styles.titleContent,
  textPlaceholder,
  textProps: {
    clampLines: textClampLines = ENTITY_PROFILE_HEADER_TEXT_CLAMP_LINES,
    isOpen: isTextOpen = true,
    onClickEditButton: onClickTextEditButton = onClickEditTitleButton,
    ...textProps
  } = EMPTY_OBJECT,
  toggleButtonProps: {
    className: toggleButtonClassName,
    ...toggleButtonProps
  } = EMPTY_OBJECT,
}) {
  const handleClickBackBtn = useNavigateBack(sectionBackUrl)

  const titleClassName = classNames(className, {
    [openClassName]: isHeaderOpen,
    [styles.withoutBackButton]: !BackButton,
  })

  const preparedStatusClassName = classNames(
    styles.status,
    statusClassName ?? styles.statusTag
  )

  return (
    <div className={titleClassName}>
      {BackButton ? (
        <BackButton
          {...backButtonProps}
          className={backButtonClassName}
          isLoading={isLoading}
          onClick={handleClickBackBtn}
        />
      ) : null}
      <div className={textContainerClassName}>
        {EntityAvatar ? (
          <div className={styles.avatarWrapper}>
            <EntityAvatar {...entityAvatarProps} isLoading={isLoading} />
          </div>
        ) : null}
        <Text
          {...textProps}
          clampLines={textClampLines}
          isArchived={isArchived}
          isLoading={isLoading}
          isOpen={isTextOpen}
          text={text}
          textPlaceholder={textPlaceholder}
          onClickEditButton={onClickTextEditButton}
        />
      </div>
      {Status ? (
        <Status
          {...statusProps}
          className={preparedStatusClassName}
          height={statusHeight}
          isLoading={isLoading}
          textClassName={statusTextClassName}
        />
      ) : null}
      <div className={styles.actions}>
        {Actions ? (
          <Actions {...restActionsProps} isLoading={isLoading} />
        ) : null}
        {ToggleButton ? (
          <ToggleButton
            {...toggleButtonProps}
            className={toggleButtonClassName}
            isOpen={isHeaderOpen}
            onClick={onToggleHeader}
          />
        ) : null}
      </div>
    </div>
  )
}

export default EntityProfileHeaderTitleWithStatus
